var path = '/app/pages/invitations/invitations.html';
var html = "";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/invitations/invitations.html
// module id = 997
// module chunks = 0